import { MainNavScreens, LeftNavStyle, firestoreDocPreferencesSchema } from "breadcommon";
import { FirestoreCollectionNames, FirestoreDocPreferences } from "breadcommon";
import { getApp } from "firebase/app";
import {
  DocumentData,
  DocumentReference,
  Unsubscribe,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  setDoc,
} from "firebase/firestore";
import { defaultInitialPreferences } from "./PreferencesContext";

function preferencesDoc(
  userId: string,
): DocumentReference<DocumentData, DocumentData> {
  const db = getFirestore(getApp());
  return doc(
    db,
    FirestoreCollectionNames.users.name,
    userId,
    FirestoreCollectionNames.users.userDocs.name,
    FirestoreCollectionNames.users.userDocs.docs.preferences.doc_id,
  );
}

export function firestoreDocPreferencesSubscribe(
  userId: string,
  save: (newPreferences: FirestoreDocPreferences) => void,
  markInitialLoadComplete: () => void,
): Unsubscribe {
  return onSnapshot(preferencesDoc(userId), async (querySnapshot) => {
    const preferencesParseResult = firestoreDocPreferencesSchema.safeParse(
      querySnapshot.data(),
    );
    if (!preferencesParseResult.success) {
      return;
    }
    markInitialLoadComplete();
    save(preferencesParseResult.data);
  });
}

export async function preferencesExists(userId: string): Promise<boolean> {
  const doc = await getDoc(preferencesDoc(userId));
  return doc.exists();
}

export async function setInitialPreferences(userId: string): Promise<void> {
  return setDoc(preferencesDoc(userId), defaultInitialPreferences);
}

async function updateWebPreference(
  userId: string,
  update: Partial<FirestoreDocPreferences["web"]>,
): Promise<void> {
  return setDoc(preferencesDoc(userId), { web: update }, { merge: true });
}

export async function setWebHomeScreenPreference(
  userId: string,
  homeScreen: MainNavScreens,
): Promise<void> {
  return updateWebPreference(userId, { home_screen: homeScreen });
}

export async function setWebHideDollarAmountsPreference(
  userId: string,
  hideDollarAmounts: boolean,
): Promise<void> {
  return updateWebPreference(userId, {
    hide_dollar_amounts: hideDollarAmounts,
  });
}

export async function setWebLeftNavStylePreference(
  userId: string,
  style: LeftNavStyle,
): Promise<void> {
  return updateWebPreference(userId, { left_nav_style: style });
}

export async function setWebDefaultCurrencyPreference(
  userId: string,
  currency: string,
): Promise<void> {
  return updateWebPreference(userId, { default_currency: currency });
}
